import { useState, useEffect } from "react";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Services } from "@/components/landing/Services";
import { Hosting } from "@/components/landing/Hosting";
import { Cases } from "@/components/landing/Cases";
import { Contact } from "@/components/landing/Contact";
import { Marquee, Footer } from "@/components/landing/Footer";
import { ChatWidget } from "@/components/landing/ChatWidget";

export default function Landing() {
  const [dark, setDark] = useState(() => localStorage.getItem("wynova-theme") === "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("wynova-theme", dark ? "dark" : "light");
  }, [dark]);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-background text-foreground">
      <Header dark={dark} onToggleTheme={() => setDark((d) => !d)} />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Hosting />
        <Cases />
        <Contact />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
